export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '996add9', dateTime: 1788965615145 };